import { render, staticRenderFns } from "./JwsDataSync.vue?vue&type=template&id=95f3a37a"
import script from "./JwsDataSync.vue?vue&type=script&lang=js"
export * from "./JwsDataSync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports